// removed by extract-text-webpack-plugin
module.exports = {"dataTable":"src-scripts-components-ReportDisplay-ReportTable-__reportTable___dataTable","upperMargin":"src-scripts-components-ReportDisplay-ReportTable-__reportTable___upperMargin","reportTable":"src-scripts-components-ReportDisplay-ReportTable-__reportTable___reportTable","multipleCellData":"src-scripts-components-ReportDisplay-ReportTable-__reportTable___multipleCellData","placeholder":"src-scripts-components-ReportDisplay-ReportTable-__reportTable___placeholder"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/ReportDisplay/ReportTable/reportTable.css
// module id = 2787
// module chunks = 0